import { generatePath } from "react-router";
import { BrowserStorage } from "utils/BrowserStorage";
import { getUrlParams } from "utils/getUrlParams";
// ev - easy viewer; ov - online viewer; ofv - office viewer (wopi viewer);

export enum ViewerType {
  EV = "ev",
  OV = "ov",
  XV = "xv",
}

interface FullscreenUrlConfig {
  projectId: number;
  fileId: number;
  fileName?: string;
  viewerType: ViewerType;
  archived?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  viewerOptions?: any;
}

export const viewFileFullscreen = (config: FullscreenUrlConfig) => {
  let path = generatePath("/view/:projectId/:viewer/:fileId", {
    projectId: config.projectId.toString(),
    fileId: config.fileId.toString(),
    viewer: config.viewerType,
  }).substr(1);
  const additonalParams = [];
  const { linkid } = getUrlParams(window.location.search);
  if (config.archived) {
    additonalParams.push("archived=true");
  }
  if (linkid) {
    additonalParams.push("linkid=" + linkid);
  }
  if (config.fileName) {
    additonalParams.push("fileName=" + config.fileName);
  }
  path += "?" + additonalParams.join("&");

  if (config.viewerOptions) {
    BrowserStorage.storePermanent("viewerOptions", config.viewerOptions);
  }
  window.open(`${window.location.origin}/${window.GLOBAL.ROUTER_BASE}/${path}`, "_blank");
};
